export const data = [
  {
    title: "カスハラへの対応姿勢",
    content:
      "お客様等の要求・言動がカスハラに該当すると当グループが判断した場合、当該行為に関する対応や状況に応じて、その後のご利用・お問い合わせ対応をお断りすることがあります。必要に応じて警察・弁護士等に相談し、法的措置を含む適切な対応を行います。",
  },
  {
    title: "カスハラの定義",
    content:
      "お客様からの苦情・言動のうち、要求の内容が明らかに行き過ぎているもの、または内容に比べて伝え方・手段が常識の範囲を超えており、その結果、当グループの社員等が強い精神的・身体的な負担を受け、安心して働けなくなるおそれのあるものを指します。",
    itemHeading: "【該当する行為の例】",
    itemList: [
      "顧客として優遇されることを目的とした言動（優越的地位の濫用）",
      "代金に見合わない過度な要求",
      "特別な利益や便宜の提供を求める要求",
      "法令違反（違法行為）となるような対応の要求",
      "身体的な攻撃（暴行、傷害など）",
      "精神的な攻撃（脅迫、中傷、名誉毀損、侮辱、暴言など）",
      "威圧的な言動や土下座の要求",
      "一方的な主張を執拗に繰り返す行為",
      "合理的な理由のない長時間の拘束（不退去、居座り、監禁など）",
      "差別的な言動や人格を否定する言動",
      "個人へのつきまとい、待ち伏せ、無断での撮影など",
    ],
    itemNote: "※以下は一例であり、これらに限られません。",
  },
]
